import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/**
 * "Tour this page" for Settings (/settings → SettingsPage.tsx). The menu anchor lives in
 * SettingsLayout.tsx and the contact card in BrandContactCard.tsx.
 */
export function getSettingsTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Settings',
        description:
          'Your site’s logo, color and fonts, your time zone, and where your other account ' +
          'settings live.',
      },
    },
    {
      element: at('settings-menu'),
      popover: {
        title: 'The settings menu',
        description:
          'Branding is this page. Domains connects your own web address, Integrations holds a few ' +
          'service keys, Team is who can log in, Lead Routing shares leads with your agents, and ' +
          'Legal Pages creates your privacy policy and terms.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: at('settings-branding'),
      popover: {
        title: 'Logo, color and fonts',
        description:
          'Paste your logo’s web address, pick your main brand color, and choose fonts for this ' +
          'site’s headings and text.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('settings-contact'),
      popover: {
        title: 'Where new-lead alerts go',
        description:
          'Your company name and contact details come from your brand, so you edit them in Brand ' +
          'Manager. “New-lead alerts go to” shows the email that gets your lead alerts — if it ' +
          'differs from the one on your site, you’ll see a warning here.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('settings-timezone'),
      popover: {
        title: 'Time zone',
        description:
          'Used for texting quiet hours and your monthly reports. Texts to your leads only go out ' +
          'between 8am and 9pm in this time zone.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('settings-save'),
      popover: {
        title: 'Save',
        description: 'Click Save Settings to keep your changes.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
